module.exports = __webpack_public_path__ + "static/media/DS-CMS-Import-en.841576dc.xlsx";